import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  profileStats: {
    padding: `0 ${theme.spacing.space20}px`,
    gap: theme.spacing.space8,
    display: "flex",
    flexDirection: "column",
  },
  statItem: {
    display: "flex",
    justifyContent: "space-between",
    background: theme.colors.background6,
    color: theme.colors.text1,
    padding: theme.spacing.space12,
    borderRadius: theme.spacing.space12,
    alignItems: "center",
  },
  label: { display: "flex", alignItems: "center", gap: theme.spacing.space12 },
  icon: { width: theme.spacing.space24 },
  value: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.space4,
  },
}));
